<article class="question-container border border-dark" [ngClass] = "{'box-grey-content':auctionItemStatus !== 'ACTIVE'}">
  <lib-state-indicator
    [variant]="questionStatus"
    [identifier]="'inventory_question_status_' + identifier"
  ></lib-state-indicator>
  <div class="question-container__meta" role="alert">
    <div [attr.aria-label]="dealer.dealerName" [ngClass]="{'question-container__meta-title-greyed-out':auctionItemStatus !== 'ACTIVE',
    'question-container__meta-title':auctionItemStatus === 'ACTIVE'}">
      {{ showDealershipName ? dealer.dealerName : dealer.smartAuctionId }}
    </div>
  </div>

  <div class="question-container__user-block">
    @for (userQuestion of dealer.userQuestions; track userQuestion; let j = $index) {
      <div
        class="user-block-container"
        [ngClass]="{ borderQuestion: j !== 0 && !toggleActiveQuestion }"
        >
        @if (selectedQuestion === userQuestion || !selectedQuestion) {
          <lib-question-block
            [id]="'question-block-container__' + userQuestion.userUuid"
            [identifier]="(identifier + j).toString()"
            [questions]="userQuestion.questions"
            [open]="toggleActiveQuestion"
            (toggleActiveQuestion)="toggleDrawer(userQuestion)"
            [dealerUuid]="dealer.dealerUuid"
            (userUuid)="setUserUuid($event)"
            [showUserName]="showUserName"
          ></lib-question-block>
        }
      </div>
    }
  </div>

  @if (selectedQuestion) {
    <lib-question-drawer
      (toggleActiveQuestion)="toggleDrawer(selectedQuestion)"
      [open]="toggleActiveQuestion"
      [dealer]="dealer"
      [questionIndex]="identifier"
      [userUuid]="userUuid"
    ></lib-question-drawer>
  }
</article>
